'use strict';

/**
 * Get object value by path
 *
 * @param {Object} object
 * @param {string} path
 * @return {*}
 */
export function get(object, path) {
    return path.split('.').reduce((prev, curr) => prev ? prev[curr] : undefined, object || {});
}

/**
 * Check object
 *
 * @param {Object} obj
 * @return {boolean}
 */
export function isEmpty(obj) {
    return obj.constructor === Object && Object.keys(obj).length === 0;
}



// WEBPACK FOOTER //
// ./src/utils/object.js